import * as React from "react";
import { observer } from "mobx-react-lite";
import { ModalPlm } from "src/components/ModalPlm";
import { Input, InputRef, notification } from "antd";
import { onError } from "src/common/onError";
import { Mc2EntityStore } from "./Mc2EntityStore";

interface PropsMc2ImportModal {
  store: Mc2EntityStore;
}

export const Mc2ImportModal: React.FC<PropsMc2ImportModal> = observer(
  ({ store }) => {
    const [text, setText] = React.useState("");
    const iref = React.useRef<InputRef>(null);
    const open = store.mode === "import";
    React.useEffect(() => {
      if (open) {
        setText("");
        setTimeout(() => {
          iref.current?.focus();
        }, 10);
      }
    }, [open]);
    return (
      <ModalPlm
        title="Импорт значений в таблицу"
        open={open}
        width="80vw"
        height="90vh"
        okText="Импортировать"
        okButtonProps={{
          disabled: !text,
          loading: store.taskType === "import",
        }}
        onOk={() => {
          store
            .doImport(text)
            .then(() =>
              notification.success({ message: "Выполнен импорт данных" }),
            )
            .catch(onError);
        }}
        onCancel={() => store.setMode(null)}
        centered
      >
        <Input.TextArea
          ref={iref}
          allowClear
          value={text}
          onChange={(e) => {
            setText(e.currentTarget.value);
          }}
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </ModalPlm>
    );
  },
);
